import React from 'react';
import styled from 'styled-components';
import Modal from 'sub_components/Common/PortalModalNew';
import { PortraitModal } from 'styled_components/Common/PortraitModal';

const PortraitModalComponentStyle = styled.div`
	position: absolute;
`;

export const PortraitModalComponent = ({
	show,
	closeModal,
	size,
	children,
	header,
	title,
	subTitle,
	customClassName,
	breakpoint,
}) => {
	return (
		<PortraitModalComponentStyle>
			{show && (
				<Modal>
					<div className='modal-background'>
						<PortraitModal
							closeModal={closeModal}
							size={size}
							header={header}
							title={title}
							subTitle={subTitle}
							customClassName={customClassName}
							breakpoint={breakpoint}
						>
							{children}
						</PortraitModal>
					</div>
				</Modal>
			)}
		</PortraitModalComponentStyle>
	);
};
